import { TrackingEventsV2 } from '@/analytics/eventsV2';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/new/components/shadcn/tooltip';
import { cn } from '@/new/lib/utils';

interface ExtractFactsFromSelectionButtonProps {
  isSelectionMode: boolean;
  setIsSelectionMode: (mode: boolean) => void;
  docId: string;
}

export const ExtractFactsFromSelectionButton = ({
  isSelectionMode,
  setIsSelectionMode,
  docId,
}: ExtractFactsFromSelectionButtonProps) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="blue"
          size="iconSm"
          className={cn(isSelectionMode ? 'border-sky-600 bg-sky-100' : '')}
          onClick={() => {
            if (!isSelectionMode) {
              trackCustomEvent(TrackingEventsV2.SelectToCreateFactFromImageSelection, { docId });
            }
            setIsSelectionMode(!isSelectionMode);
          }}
        >
          <Icon className="lucide--crop" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <p>{isSelectionMode ? 'Exit selection mode' : 'Select an area of the document to extract facts from it.'}</p>
      </TooltipContent>
    </Tooltip>
  );
};
